import SbuxStyledTableRow from "../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../components/SbuxTable/SbuxStyledTableCell";
import InputTableCell from "./InputTableCell";
import SbuxContentCopy from "../../../../components/SbuxContentCopy";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  isPhoneNumber,
  phoneNumberDetail,
} from "../../../../utils/phoneNumber";
import { isTicketOrCaseEditable } from "../utils";
import { getHistoryUpdatedTimezone } from "../../utils";
import { useAppSelector } from "../../../../store/types";
import { getTimezoneSelector } from "../../../../selectors/settingsSelector";

import React from "react";

interface DetailRowProps {
  row: {
    detailsRows?: Array<{ name: string; value: string }>;
    ContactID?: string | null;
    timestamp?: string | null;
    [key: string]: unknown;
  };
  linkRenderer: (value: string) => React.ReactNode;
}

const DetailRow = ({ row, linkRenderer }: DetailRowProps) => {
  const userTimezone = useAppSelector(getTimezoneSelector);
  const callInfo: Record<string, unknown> = {};
  return (
    <>
      {row.detailsRows &&
        row.detailsRows.map((contact, index) => {
          callInfo[contact.name] = contact.value;
          return (
            <SbuxStyledTableRow
              key={index}
              sx={{ "& > *": { borderBottom: "unset" } }}
            >
              <SbuxStyledTableCell>
                <SbuxTranslate>{contact.name}</SbuxTranslate>
              </SbuxStyledTableCell>
              <SbuxStyledTableCell>
                {contact.name === "Ticket or Case #" &&
                isTicketOrCaseEditable(callInfo) ? (
                  <InputTableCell
                    row={contact}
                    contactId={row.ContactID ?? null}
                    timeStamp={row.timestamp ?? ""}
                  />
                ) : (
                  <span>
                    {contact.name === "Time" && row.timestamp ? (
                      getHistoryUpdatedTimezone(
                        row as Record<string, unknown>,
                        userTimezone,
                      )
                    ) : isPhoneNumber(String(contact.value)) ? (
                      <div>
                        {linkRenderer(String(contact.value))}
                        <SbuxContentCopy
                          content={
                            phoneNumberDetail(String(contact.value))
                              ?.phoneNumber ?? ""
                          }
                        />
                      </div>
                    ) : (
                      contact.value
                    )}
                  </span>
                )}
              </SbuxStyledTableCell>
            </SbuxStyledTableRow>
          );
        })}
    </>
  );
};

export default DetailRow;
